export enum AssignmentType {
  CURRICULUM = "CURRICULUM",
  ASSESSMENT = "ASSESSMENT",
  INSTRUCT = "INSTRUCT",
  SKIP_OVERRIDE = "SKIP_OVERRIDE",
}
